// ImagesLanding.jsx
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Navbar from "../components/Navbar";
import "./ImagesLanding.css";
import { FaImages, FaUpload } from "react-icons/fa";
import DonationButton from "../components/DonationButton";
import DonationWheel from "../components/DonationWheel";
import ImageUploadModal from "../components/ImageUploadModal";
import ImageResultModal from "../components/ImageResultModal";
import "../containers/ModalTheme.css";
import "../containers/GroupPageCards.css";
import { useScene } from "../components/scene/SceneContext";
import SceneBackground from "../components/scene/SceneBackground";

export default function ImagesLanding() {
  const history = useHistory();
  const { variant } = useScene();
  const logoSrc = `${process.env.PUBLIC_URL}/images/logo/logo.png`;
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const handleUploadSuccess = (result) => {
    setUploadResult(result);
    setShowResultModal(true);
  };

  return (
    <div className={`d-flex flex-column inner-height images-landing images-landing--${variant}`}>
      <SceneBackground effectsProps={{ preset: "landing", showAnimals: true }} />
      <Navbar
        actionBtnIconClassName="bi-arrow-left"
        showActionBtn
        handleActionBtnOnClick={() =>
          history.push(`${process.env.PUBLIC_URL}/`)
        }
        rightSlot={
          <>
            <DonationButton className="btn btn-sm as-btn-soft" />
            <button 
              className="btn btn-sm as-btn-soft" 
              onClick={() => history.push(`${process.env.PUBLIC_URL}/games`)}
              title="Games"
            >
              🎮
            </button>
          </>
        }
      />
       

      <div className="container-xl flex-grow-1 text-center d-flex flex-column justify-content-center images-content">
        <div className="images-hero-card as-theme">
          <div className="images-hero-top">
            <div className="images-hero-mascot" aria-hidden="true">
              <img className="images-hero-logo" src={logoSrc} alt="" />
            </div>
            <h1 className="images-title">
              <span className="images-typing-text">AnimalSplit</span>
              <span className="images-badge-container">
                <FaImages className="images-badge-icon" />
                <span className="images-badge-text">Images</span>
              </span>
            </h1>
          </div>

          <div className="images-animal-strip" aria-hidden="true">
            📸🖼️🎨🐶🐱🦊🐻🐼🌸🌿
          </div>

          <p className="images-slogan">
            Upload public image resources for your games
          </p>

          <div className="images-actions">
            <button 
              className="btn btn-lg as-btn-primary-gradient" 
              onClick={() => setShowUploadModal(true)}
            >
              <FaUpload className="me-2" />
              Upload Images
            </button>
          </div>
        </div>
      </div>
      <DonationWheel />
      
      <ImageUploadModal 
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadSuccess={handleUploadSuccess}
      />
      
      <ImageResultModal
        show={showResultModal}
        onHide={() => setShowResultModal(false)}
        result={uploadResult}
      />
    </div>
  );
}
